import React, { useEffect, useState } from "react";
import { HiInformationCircle } from "react-icons/hi";
import { Link } from "react-router-dom";
import { Trans, t } from "@lingui/macro";

import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";

const BuyPlpModal = ({ open, setOpen, action }: { open: boolean; setOpen: () => void; action: "buy" | "sell" }) => {
  const [hideModal, setHideModal] = useState(false);

  const getTitle = () => {
    if (action === "buy") {
      return t`PLP Staked Successfully`;
    } else return t`PLP Unstaked Successfully`;
  };

  const getInfoText = () => {
    if (action === "buy") {
      return t`Your purchased PLP tokens are now in the staking pool to earn 50% of the trading fees generated by the Palmswap Exchange. You can sell the PLP tokens at any time, and your tokens will automatically become unstaked.`;
    } else
      return t`Your PLP tokens were successfully sold and unstaked. The rewards you have received so far can be claimed even after you have sold PLP, but you will not receive any new rewards.`;
  };

  const stakeLink = "/earn";

  useEffect(() => {
    if (hideModal) {
      localStorage.setItem("doNotShowModalAfterBuyOrSellPLP", JSON.stringify(hideModal));
    } else {
      localStorage.setItem("doNotShowModalAfterBuyOrSellPLP", JSON.stringify(hideModal));
    }
  }, [hideModal]);

  const isModalVisible = !hideModal && open;

  return (
    <Modal className="Buy-plp-modal" isVisible={isModalVisible} setIsVisible={setOpen} label={`${getTitle()}`}>
      <div className="flex w-[42rem] flex-col tailwind isolate">
        <div className="border border-border rounded-[1rem] px-[1.4rem] py-[1.8rem] flex text-inactive gap-[0.8rem] text-[1.4rem] w-full">
          <HiInformationCircle />
          <div className="w-fit">{getInfoText()}</div>
        </div>
      </div>

      <div className="flex items-center mt-[1.4rem] mb-[2.8rem]">
        <input
          type="checkbox"
          className="Buy-checkbox"
          id="Buy-checkbox"
          checked={hideModal}
          onChange={() => setHideModal(!hideModal)}
        />
        <label htmlFor="Buy-checkbox">
          <span className="ml-[0.8rem] text-inactive text-[1.4rem whitespace-nowrap">
            <Trans>Don’t show this message again</Trans>
          </span>
        </label>
      </div>

      <Link to={stakeLink} className="no-underline">
        <Button variant={"primary-action"} className="w-full">
          <Trans>Visit 'Stake PLP'</Trans>
        </Button>
      </Link>
    </Modal>
  );
};

export default BuyPlpModal;
